export type {
  EntityMetadata,
  EntityRegistry,
  RelationSpec,
} from '../engine/types'

import { countEntitiesTool } from './primitives/count_entities'
import { getCurrentPageTool } from './primitives/get_current_page'
import { getEntityTool } from './primitives/get_entity'
import { getRelatedTool } from './primitives/get_related'
import { getSchemaTool } from './primitives/get_schema'
import { getWriteSchemaTool } from './primitives/get_write_schema'
import { listEntitiesTool } from './primitives/list_entities'
import { navigateToTool } from './primitives/navigate_to'
import { searchEntitiesTool } from './primitives/search_entities'
import { showOptionsTool } from './primitives/show_options'
import { createEntityTool } from './primitives/write/create_entity'
import { relateEntityTool } from './primitives/write/relate_entity'
import { updateEntityTool } from './primitives/write/update_entity'
import type { AiChatBotTool } from '@/Atomic/Widgets/AiChatBot/core/engine/types'

// Cast: defineTool<T> returns AiChatBotTool<T>; array requires AiChatBotTool<unknown>.
// The contravariance is safe because tool-system validates args via schema.parse before
// passing them to run(). One cast here replaces per-tool casts at every call site.

export const READ_TOOLS: AiChatBotTool<unknown>[] = [
  countEntitiesTool,
  getCurrentPageTool,
  searchEntitiesTool,
  getEntityTool,
  getRelatedTool,
  listEntitiesTool,
  getSchemaTool,
  showOptionsTool,
  navigateToTool,
] as AiChatBotTool<unknown>[]

export const WRITE_TOOLS: AiChatBotTool<unknown>[] = [
  getWriteSchemaTool,
  createEntityTool,
  updateEntityTool,
  relateEntityTool,
] as AiChatBotTool<unknown>[]
